module.exports = __webpack_public_path__ + "img/header_code.94cc38f2.png";